import React from "react";
import { ChecklistManagementBaseUrl } from "./../../../constants/apiUrls";
import DataSourceDropdownComponent from "./DataSourceDropdownComponent";

const ChecklistTemplateDropdown = ({
  resources,
  checklistTemplateId,
  onChecklistTemplateChange,
  containerClass,
  id = "checklistTemplate-dropdown",
  disabled = false,
  required = false,
}) => {
  return (
      <DataSourceDropdownComponent
        id={id}
        labelText={resources["AddChecklistTemplate"]}
        value={checklistTemplateId}
        placeholder={resources["Select"]}
        handleChange={onChecklistTemplateChange}
        inputName="checklistTemplate"
        addMarginBottom={false}
        disabled={disabled}
        required={required}
        containerClass={containerClass}
        sourceUrl={ChecklistManagementBaseUrl()}
        filter={(a) => a.isActive === true}
        map={(a) => ({ key: a.id, name: a.description })}
        sort={(a, b) => (a.description > b.description ? 1 : -1)}
      />
  );
};

export default ChecklistTemplateDropdown;
